import style from '../CSS/RoundVideoResult.module.css'

import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css'
import SliderItem from "./SliderItem";

import sliderOne from '../img/sliderOne.png';
import sliderTwo from '../img/sliderThree.png';
import sliderThree from '../img/sliderTwo.png';
import sliderFour from '../img/sliderOne.png';
import sliderFive from '../img/sliderTwo.png';
import sliderSix from '../img/sliderThree.png';

const sliders = [
    {slider: sliderOne},
    {slider: sliderTwo},
    {slider: sliderThree},
    {slider: sliderFour},
    {slider: sliderFive},
    {slider: sliderSix},
]

const Slider = () => {
    return (
        <>
            <div className={style.slider}>
                <OwlCarousel className='owl-theme' items={7} autoplay loop margin={10} nav>
                    {
                        sliders.map((item)=>(
                            <div className='item'>
                                <SliderItem image={item.slider}/>
                            </div>
                        ))
                    }

                    {/*<div className='item'>
                        <h4>2</h4>
                    </div>
                    <div className='item'>
                        <h4>3</h4>
                    </div>
                    <div className='item'>
                        <h4>4</h4>
                    </div>
                    <div className='item'>
                        <h4>5</h4>
                    </div>
                    <div className='item'>
                        <h4>6</h4>
                    </div>
                    <div className='item'>
                        <h4>7</h4>
                    </div>
                    <div className='item'>
                        <h4>8</h4>
                    </div>
                    <div className='item'>
                        <h4>9</h4>
                    </div>
                    <div className='item'>
                        <h4>10</h4>
                    </div>
                    <div className='item'>
                        <h4>11</h4>
                    </div>
                    <div className='item'>
                        <h4>12</h4>
                    </div>*/}
                </OwlCarousel>
            </div>
        </>
    );
};

export default Slider;